module.exports = __webpack_public_path__ + "img/clipboard-check-duotone.ff13b412.svg";